module.exports =
{
  bedrooms: require('./WiFiGuarantee/bedrooms'),
  floors: require('./WiFiGuarantee/floors'),
  confirm: require('./WiFiGuarantee/confirm'),
  modals: require('./WiFiGuarantee/modals'),
  terms: require('./WiFiGuarantee/terms'),
  buyPods: require('./WiFiGuarantee/buyPods'),
}